import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Text, Pressable, Animated, Easing } from 'react-native';
import { ConfigContext } from '../../ConfigProvider/rn/context';
import { useTracking } from '../../../hooks/rn/useTracking';
import Loading from '../../../assets/images/rn/Loading';
import * as RNStyle from '../../../styles/rn';
import { FONT_WEIGHT_REGULAR } from '../../../styles/rn';
import { CustomStyleSheet } from '../../../utils/rn/tools';
export var Button = function Button(props) {
  var _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    text = props.text,
    action = props.action,
    multiple_action = props.multiple_action,
    _props$styles = props.styles,
    stylesProps = _props$styles === void 0 ? {} : _props$styles,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? false : _props$loading,
    children = props.children,
    numberOfLines = props.numberOfLines,
    isUIOptimisationButton = props.isUIOptimisationButton,
    _props$hasAutoPopup = props.hasAutoPopup,
    hasAutoPopup = _props$hasAutoPopup === void 0 ? false : _props$hasAutoPopup;
  var type = props.type === 'frameless' ? 'secondary-outlined' : props.type || 'default';
  var _stylesProps$containe = stylesProps.containerStyle,
    containerStyle = _stylesProps$containe === void 0 ? {} : _stylesProps$containe,
    _stylesProps$textStyl = stylesProps.textStyle,
    textStyle = _stylesProps$textStyl === void 0 ? {} : _stylesProps$textStyl;
  var context = useContext(ConfigContext);
  var haveUIOptimisationButton = isUIOptimisationButton && !disabled;
  /**
   * TODO: tracker
   */

  var _useTracking = useTracking(props),
    tracker = _useTracking.tracker,
    trackingClick = _useTracking.trackingClick,
    trackingImpressionProps = _useTracking.trackingImpressionProps; // useEffect(() => {
  //   // TODO: 在 RN 的 tracker 写好之前，先手动触发 impression 上报
  //   // 因为 button 的 click上报和 impression 上报的字段是一样的，所以这里直接用 click 的上报数据
  //   if (Platform.OS === 'web') {
  //     trackingClick &&
  //       dataMaintainer.tracker?.dispatchTrack({
  //         operation: TRACKING_OPERATION.IMPRESSION,
  //         section: trackingClick.trackingsection,
  //         target: TRACKING_TARGET.button,
  //         data: { viewed_objects: [{ ...(trackingClick?.data || {}) }] },
  //       });
  //   }
  // }, []);

  var _useState = useState(hasAutoPopup),
    _useState2 = _slicedToArray(_useState, 2),
    hasEmitedAutoAction = _useState2[0],
    setHasEmitedAutoAction = _useState2[1];
  var rotateAnimate = useRef(new Animated.Value(0)).current;
  var rotateInterpolation = rotateAnimate.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '360deg']
  });
  var onClick = function onClick(e) {
    var _e$stopPropagation, _props$trackingData, _props$trackingData$t, _context$eventEmitter, _context$eventEmitter2, _props$onClick;
    e === null || e === void 0 ? void 0 : (_e$stopPropagation = e.stopPropagation) === null || _e$stopPropagation === void 0 ? void 0 : _e$stopPropagation.call(e); // 点击埋点

    trackingClick && tracker.click(_objectSpread(_objectSpread({}, trackingClick), {}, {
      data: _objectSpread(_objectSpread({}, (trackingClick === null || trackingClick === void 0 ? void 0 : trackingClick.data) || {}), (_props$trackingData = props.trackingData) === null || _props$trackingData === void 0 ? void 0 : (_props$trackingData$t = _props$trackingData.trackingdataClick) === null || _props$trackingData$t === void 0 ? void 0 : _props$trackingData$t.call(_props$trackingData, _objectSpread(_objectSpread({}, props.componentData || {}), {}, {
        disabled: disabled
      })))
    }));
    if (disabled) {
      var _props$onDisableClick;
      (_props$onDisableClick = props.onDisableClick) === null || _props$onDisableClick === void 0 ? void 0 : _props$onDisableClick.call(props, e);
      return;
    }
    if (loading) {
      var _props$onLoadingClick;
      (_props$onLoadingClick = props.onLoadingClick) === null || _props$onLoadingClick === void 0 ? void 0 : _props$onLoadingClick.call(props, e);
      return;
    }
    action && (context === null || context === void 0 ? void 0 : (_context$eventEmitter = context.eventEmitter) === null || _context$eventEmitter === void 0 ? void 0 : (_context$eventEmitter2 = _context$eventEmitter.emit) === null || _context$eventEmitter2 === void 0 ? void 0 : _context$eventEmitter2.call(_context$eventEmitter, action === null || action === void 0 ? void 0 : action.func, {
      id: props._id,
      text: text,
      action: action,
      multiple_action: multiple_action
    }, action.callback));
    (_props$onClick = props.onClick) === null || _props$onClick === void 0 ? void 0 : _props$onClick.call(props, e);
  };
  useEffect(function () {
    var _action$return_item_i, _action$return_item_i2;
    if (disabled || hasEmitedAutoAction) {
      return;
    }
    if ((action === null || action === void 0 ? void 0 : action.func) === 'autoPopupDriverOrderList' || (action === null || action === void 0 ? void 0 : action.func) === 'popupSelectOrder' || (action === null || action === void 0 ? void 0 : action.func) === 'popupSelectProduct' || (action === null || action === void 0 ? void 0 : action.func) === 'popupRRUploadEvidence' || (action === null || action === void 0 ? void 0 : action.func) === 'popupRROrderSelector' && !((action === null || action === void 0 ? void 0 : (_action$return_item_i = action.return_item_info) === null || _action$return_item_i === void 0 ? void 0 : _action$return_item_i.is_second_round) !== undefined && (action === null || action === void 0 ? void 0 : (_action$return_item_i2 = action.return_item_info) === null || _action$return_item_i2 === void 0 ? void 0 : _action$return_item_i2.is_second_round) === true)) {
      var _context$eventEmitter3, _context$eventEmitter4;
      context === null || context === void 0 ? void 0 : (_context$eventEmitter3 = context.eventEmitter) === null || _context$eventEmitter3 === void 0 ? void 0 : (_context$eventEmitter4 = _context$eventEmitter3.emit) === null || _context$eventEmitter4 === void 0 ? void 0 : _context$eventEmitter4.call(_context$eventEmitter3, action === null || action === void 0 ? void 0 : action.func, {
        id: props._id,
        text: text,
        action: action
      }, action.callback);
      setHasEmitedAutoAction(true);
    }
  }, [props, hasEmitedAutoAction]);
  useEffect(function () {
    Animated.loop(Animated.timing(rotateAnimate, {
      toValue: 1,
      duration: 1000,
      easing: Easing.linear,
      useNativeDriver: true
    })).start();
  }, []);
  var getOpacityStyle = function getOpacityStyle(pressed) {
    var opacity = undefined;
    if (pressed) {
      if (loading) {
        opacity = 0.8;
      } else {
        opacity = 0.75;
      }
    }
    return {
      opacity: opacity
    };
  };
  return /*#__PURE__*/React.createElement(Pressable, _extends({
    onPress: onClick,
    style: function style(_ref) {
      var pressed = _ref.pressed;
      return [styles.button, styles["button-".concat(type)], getOpacityStyle(pressed), disabled && styles["button-".concat(type, "__disabled")], loading && styles.button__loading, haveUIOptimisationButton && styles['ui-optimisation-button'], haveUIOptimisationButton && styles["ui-optimisation-button-".concat(type)], containerStyle];
    }
  }, trackingImpressionProps), loading ? /*#__PURE__*/React.createElement(Animated.View, {
    style: [styles['button-loading-icon-container'], {
      transform: [{
        rotate: rotateInterpolation
      }]
    }]
  }, /*#__PURE__*/React.createElement(Loading, null)) : null, children !== null && children !== void 0 ? children : /*#__PURE__*/React.createElement(Text, {
    numberOfLines: numberOfLines,
    style: [styles['button--text'], styles["button-".concat(type, "--text")], haveUIOptimisationButton && styles['ui-optimisation-button--text'], haveUIOptimisationButton && styles["ui-optimisation-button-".concat(type, "--text")], disabled && styles["button-".concat(type, "__disabled--text")], textStyle]
  }, text));
};
/**
 * -: 未处理样式
 */

var styles = CustomStyleSheet({
  // flex-grow: 1;
  // font-size: 0.875rem;
  // line-height: 1rem;
  // text-align: center;
  // color: @brand;
  // font-weight: 400;
  // cursor: pointer; -
  // user-select: none; -
  // transition: opacity 0.1s ease-in; -
  // padding: 0.875rem 0.75rem;
  // min-width: 15.25rem;
  // word-break: break-word; -
  button: _objectSpread(_objectSpread({
    flexGrow: 1,
    fontSize: 14,
    lineHeight: 16,
    textAlign: 'center',
    color: RNStyle.brand
  }, FONT_WEIGHT_REGULAR), {}, {
    paddingHorizontal: 12,
    paddingVertical: 14,
    minWidth: 244
  }),
  'button--text': _objectSpread({
    fontSize: 14,
    lineHeight: 16,
    textAlign: 'center',
    color: RNStyle.brand
  }, FONT_WEIGHT_REGULAR),
  'button--link': {
    marginLeft: 0,
    paddingVertical: 10,
    paddingHorizontal: 12
  },
  /**
   * 不处理
   */
  // &-default__disabled,
  // &-primary__disabled,
  // &-primary-outlined__disabled,
  // &-secondary-outlined__disabled,
  // &-link__disabled,
  // &-frameless__disabled,
  // &-link__disabled,
  // &-text__disabled {
  //   cursor: not-allowed; -
  //   transition: none; -
  // }

  /**
   * 写入各个样式中
   */
  // &-primary,
  // &-primary__disabled,
  // &-primary-outlined,
  // &-secondary-outlined,
  // &-secondary-outlined__disabled,
  // &-frameless,
  // &-frameless__disabled {
  //   min-width: 13.75rem;
  // }
  // &:hover {
  //   opacity: 0.9;
  // }
  // &:active {
  //   opacity: 0.75;
  // }

  /**
   * Pressable 行内样式
   */
  // &-default {
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   flex: 1;
  //   border-top: 0.5px solid @gray-6;

  /**
   * 在button-group处理
   */
  //   // 横向布局且不是最后一个按钮
  //   .@{prefix-cls}-button-group__horizontal > &:not(:last-child) {
  //     border-right: 1px solid @gray-6;
  //   }
  //   &__disabled {
  //     color: @gray-5;
  //   }
  // }
  'button-default': {
    alignItems: 'center',
    justifyContent: 'center',
    borderTopWidth: 0.5,
    borderStyle: 'solid',
    borderTopColor: RNStyle.gray_6
  },
  'button-default__disabled': {
    color: RNStyle.gray_5
  },
  'button-default__disabled--text': {
    color: RNStyle.gray_5
  },
  // &-primary {
  //   font-size: 0.875rem;
  //   line-height: 1em;
  //   padding: 0.6875rem 0.25rem;
  //   border-top: none;
  //   background-color: @brand;
  //   margin: 0.625rem 0.75rem;
  //   color: @white;
  //   border-radius: 3px;
  //   &__disabled {
  //     background: @gray-6;
  //     color: @gray-5;
  //   }
  // }
  'button-primary': {
    minWidth: 220,
    fontSize: 14,
    lineHeight: 16,
    paddingVertical: 11,
    paddingHorizontal: 4,
    backgroundColor: RNStyle.brand,
    marginVertical: 4,
    marginHorizontal: 10,
    color: RNStyle.white,
    borderRadius: 3
  },
  'button-primary__disabled': {
    minWidth: 220,
    backgroundColor: RNStyle.gray_6,
    color: RNStyle.gray_5
  },
  'button-primary--text': {
    fontSize: 14,
    lineHeight: 16,
    color: RNStyle.white
  },
  'button-primary__disabled--text': {
    color: RNStyle.gray_5
  },
  // &-primary-outlined {
  //   font-size: 0.875rem;
  //   line-height: 1em;
  //   padding: 0.6875rem 0.25rem;
  //   border: 1px solid @brand;
  //   margin: 0.625rem 0.75rem;
  //   border-radius: 3px;
  //   &__disabled {
  //     border: 1px solid @gray-5;
  //     color: @gray-5;
  //   }
  // }
  'button-primary-outlined': {
    minWidth: 220,
    fontSize: 14,
    lineHeight: 16,
    paddingVertical: 11,
    paddingHorizontal: 4,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: RNStyle.brand,
    marginVertical: 4,
    marginHorizontal: 10,
    borderRadius: 3
  },
  'button-primary-outlined__disabled': {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: RNStyle.gray_5,
    color: RNStyle.gray_5
  },
  'button-primary-outlined--text': {
    fontSize: 14,
    lineHeight: 16
  },
  'button-primary-outlined__disabled--text': {
    color: RNStyle.gray_5
  },
  // &-secondary-outlined {
  //   font-size: 0.875rem;
  //   line-height: 1em;
  //   padding: 0.6875rem 0.25rem;
  //   border: 1px solid @gray-5;
  //   color: @gray-1;
  //   margin: 0.625rem 0.75rem;
  //   border-radius: 3px;
  //   &__disabled {
  //     border: 1px solid @gray-5;
  //     color: @gray-5;
  //   }
  // }
  'button-secondary-outlined': {
    minWidth: 220,
    fontSize: 14,
    lineHeight: 16,
    paddingVertical: 11,
    paddingHorizontal: 4,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: RNStyle.gray_5,
    color: RNStyle.gray_1,
    marginVertical: 4,
    marginHorizontal: 10,
    borderRadius: 3
  },
  'button-secondary-outlined__disabled': {
    minWidth: 220,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: RNStyle.gray_5,
    color: RNStyle.gray_5
  },
  'button-secondary-outlined--text': {
    fontSize: 14,
    lineHeight: 16,
    color: RNStyle.gray_1
  },
  'button-secondary-outlined__disabled--text': {
    color: RNStyle.gray_5
  },
  // &-frameless {
  //   font-size: 0.875rem;
  //   line-height: 1em;
  //   padding: 3px 0;
  //   border: none;
  //   color: @blue;
  //   margin: 0.625rem 0.75rem;
  //   &__disabled {
  //     color: @gray-5;
  //   }
  'button-frameless': {
    minWidth: 220,
    fontSize: 14,
    lineHeight: 16,
    paddingVertical: 3,
    paddingHorizontal: 0,
    color: RNStyle.blue,
    marginVertical: 10,
    marginHorizontal: 12
  },
  'button-frameless__disabled': {
    minWidth: 220,
    color: RNStyle.gray_5
  },
  'button-frameless--text': {
    fontSize: 14,
    lineHeight: 16,
    color: RNStyle.blue
  },
  'button-frameless__disabled--text': {
    color: RNStyle.gray_5
  },
  // &-link {
  //   padding: 0.6rem 0.75rem 0.6rem 0;
  //   color: @link;
  //   border-top: 0.5px solid @gray-6;
  //   margin-left: 0.75rem;
  //   &__disabled {
  //     color: @gray-5;
  //   }
  // }
  'button-link': {
    paddingVertical: 12,
    paddingRight: 12,
    paddingLeft: 0,
    color: RNStyle.link,
    borderTopWidth: 0.5,
    borderStyle: 'solid',
    borderTopColor: RNStyle.gray_6,
    marginLeft: 12
  },
  'button-link__disabled': {
    color: RNStyle.gray_5
  },
  'button-link--text': {
    color: RNStyle.link
  },
  'button-link__disabled--text': {
    color: RNStyle.gray_5
  },
  // &__loading {
  //   opacity: 0.7;

  /**
   * Pressable 行内样式
   */
  //   &:hover {
  //     opacity: 0.8;
  //     cursor: default;
  //   }
  // }
  button__loading: {
    opacity: 0.7,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  // &-loading-icon {
  //   display: inline-block;
  //   margin-right: 0.5rem;
  //   animation: loadingCircle 1s infinite linear;
  //   & > div {
  //     display: flex;
  //     font-size: 0;
  //   }
  //   @keyframes loadingCircle {
  //     100% {
  //       transform: rotate(360deg);
  //     }
  //   }
  // }
  'button-loading-icon-container': {
    width: 14,
    height: 14,
    marginRight: 8
  },
  // &-text {
  //   font-size: 1rem;
  //   color: @gray-1;
  //   padding: 0.875rem 0.75rem;
  //   text-align: left;
  //   line-height: 20px;
  //   border-top: 0.5px solid @gray-6;
  //   &__disabled {
  //     color: @gray-5;
  //   }
  // }
  'button-text': {
    fontSize: 16,
    color: RNStyle.gray_1,
    paddingVertical: 14,
    paddingHorizontal: 12,
    textAlign: 'left',
    lineHeight: 20,
    borderTopWidth: 0.5,
    borderStyle: 'solid',
    borderTopColor: RNStyle.gray_6
  },
  'button-text__disabled': {
    color: RNStyle.gray_5
  },
  'button-text--text': {
    fontSize: 16,
    color: RNStyle.gray_1,
    textAlign: 'left',
    lineHeight: 20
  },
  'button-text__disabled--text': {
    color: RNStyle.gray_5
  },
  'ui-optimisation-button': {
    paddingVertical: 10,
    paddingHorizontal: 16,
    borderRadius: 2
  },
  'ui-optimisation-button--text': _objectSpread(_objectSpread({
    fontSize: 14
  }, RNStyle.FONT_WEIGHT_REGULAR), {}, {
    lineHeight: 16
  }),
  'ui-optimisation-button-default': {},
  'ui-optimisation-button-default--text': {},
  'ui-optimisation-button-primary': {
    backgroundColor: 'rgba(238, 77, 45, 1)'
  },
  'ui-optimisation-button-primary--text': {},
  'ui-optimisation-button-primary-outlined': {
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: '#ee4d2d'
  },
  'ui-optimisation-button-primary-outlined--text': {
    color: 'rgba(238, 77, 45, 1)'
  },
  'ui-optimisation-button-secondary-outlined': {
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: 'rgba(0, 0, 0, 0.26)'
  },
  'ui-optimisation-button-secondary-outlined--text': {
    color: 'rgba(0, 0, 0, 0.87)'
  },
  'ui-optimisation-button-frameless': {
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: 'rgba(0, 0, 0, 0.26)',
    marginVertical: 4,
    marginHorizontal: 10
  },
  'ui-optimisation-button-frameless--text': {
    color: 'rgba(0, 0, 0, 0.87)'
  },
  'ui-optimisation-button-link': {},
  'ui-optimisation-button-link--text': {},
  'ui-optimisation-button-text': {},
  'ui-optimisation-button-text--text': {}
});